const TickGradient = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
        >
            <g clip-path="url(#clip0_5030_266689)">
                <path
                    d="M5.73317 15L4.4665 12.8667L2.0665 12.3333L2.29984 9.86667L0.666504 8L2.29984 6.13333L2.0665 3.66667L4.4665 3.13333L5.73317 1L7.99984 1.96667L10.2665 1L11.5332 3.13333L13.9332 3.66667L13.6998 6.13333L15.3332 8L13.6998 9.86667L13.9332 12.3333L11.5332 12.8667L10.2665 15L7.99984 14.0333L5.73317 15ZM7.29984 10.3667L11.0665 6.6L10.1332 5.63333L7.29984 8.46667L5.8665 7.06667L4.93317 8L7.29984 10.3667Z"
                    fill="url(#paint0_linear_5030_266689)"
                />
            </g>
            <defs>
                <linearGradient
                    id="paint0_linear_5030_266689"
                    x1="4.99984"
                    y1="-1.66667"
                    x2="12.3332"
                    y2="16.6667"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stop-color="#00CABC" />
                    <stop offset="1" stop-color="#00857C" />
                </linearGradient>
                <clipPath id="clip0_5030_266689">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default TickGradient;
